import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, withRouter } from "react-router-dom";
// import { Navbar, Dropdown, Nav } from "react-bootstrap";
import EditorSpinner from "../../../Utils/EditorSaveSpinner";
import { TemplateContext } from "../../../Context/templateContext";
import { useSelector, useDispatch } from "react-redux";
import "./EditorNavbar.scss";
import ColorPicker from "../../Colorpicker/Colorpicker";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import WarningPopup from "../../Modals/AppTemplateWarningPopup/WarningPopup";
import PreviewResume from "../../Modals/PreviewResumeModal/PreviewResumeModal";
import {
  backgroundImage,
  fontVariations,
  availableSection,
} from "../../../TemplateConfig";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import { ResumeUpdateContext } from "../../../Context/resumeUpdateContext";
import Modal from "react-bootstrap/Modal";
import DownloadPopup from "../../DownloadPopup/DownloadPopup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { userTypeContext } from "../../../Context/FreeOrProContext";

import { undoRedo } from "../../../Store/Actions/undoRedoActions";
import ReactTooltip from "react-tooltip";
import OutsideClickHandler from "react-outside-click-handler";
import { resumeEditActions } from "../../../Store/Actions/ResumeActions";
import LoginPopup from "../../Modals/LoginPopup/LoginPopup";
import SectionItem from "../../../Components/Editor/SectionItem";
import AddSectionModal from "../../Modals/AddSectionsModal/AddSectionModal";
import { ActionCreators, applyUndo, undoMiddeware } from "react-redux-undo";
import Qrtemplate from "../../Qrtemplate/Qrtemplate";
import { Dropdown, DropdownButton } from "react-bootstrap";

import Collapse from "react-bootstrap/Collapse";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CalculatecompletedPercentage } from "../../../Utils/CalculateCompletion";
import MissingFieldsPopup from "../../Modals/MissingFieldsPopup/WarningPopup";
import StepRange from "../../GraphsAndCharts/StepRange/StepRange";
import { HexColorPicker } from "react-colorful";

function EditorHeader(props) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const pathname = window.location.pathname;

  const fontSelection = [
    {
      font: [
        "Montserrat",
        "Lato",
        "Poppins",
        "Work Sans",
        "Raleway",
        "Rubik",
        "Oswald",
        "Bitter",
        "Exo 2",
        "Chivo",
        "Volkhov",
        "Inter",
        "Open Sans",
      ],
      label: "Primary Font",
      key: "primary",
      name: "titleFont",
    },
    {
      font: [
        "Montserrat",
        "Lato",
        "Poppins",
        "Work Sans",
        "Raleway",
        "Rubik",
        "Oswald",
        "Bitter",
        "Exo 2",
        "Chivo",
        "Volkhov",
        "Inter",
        "Open Sans",
      ],
      label: "Body Font",
      key: "body",
      name: "bodyFont",
    },
  ];

  const customColor = [
    {
      varient: "primaryColor",
      label: "Primary Color",
    },
    {
      varient: "secondaryColor",
      label: "Secondary Color",
    },
    {
      varient: "titleBgColor",
      label: "Section Title Background Color",
    },
    // {
    //   varient: "bgColor",
    //   label: "Page Color",
    // },
  ];

  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    setIsSample,
  } = useContext(jsonEditorContext);
  //   const { showTemplate, setShowTemplate } = useContext(TemplateContext);

  const [tempData, setTempData] = useState("");
  const [randUpdate, setRandUpdate] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showAddSection, setShowAddSection] = useState(false);
  const [showDesignSection, setShowDesignSection] = useState(false);
  const [showMediumDesignbar, setShowMediumDesignbar] = useState(false);
  const [showMissingFieldsPopup, setShowMissingFieldsPopup] = useState(false);
  const [hasClass, setHasClass] = useState(false);
  const [clickedPreview, setClickedPreview] = useState(false);
  const { improveTexts, setImproveTexts } = useContext(jsonEditorContext);
  const [customOpen, setCustomOpen] = useState(false);

  const path = window.location.pathname;

  const dropdownRef = useRef();

  const handleEventKey = (eventKey, event) => {
    props.setEditorEventKey(eventKey);
  };

  const { resume } = useSelector((state) => state.resumeGetById);
  const sleectedResume = useSelector((state) => state.resumeGetById.resume);
  const { history } = useSelector((state) => state.undoRedo);
  const historyUndoRedo = useSelector((state) => state.undoRedo);
  const templateData = useSelector((state) => state.TemplateParticular.data);

  const {
    userType,
    resumeCount,
    showProPopup,
    setShowProPopup,
    setPopupType,
    setShowProPopupMessage,
  } = useContext(userTypeContext);

  const customizationData = useSelector(
    (state) => state.editorData.customization
  );
  const dataCustomize = isJson
    ? json && json.customization && json.customization
    : props &&
      props.resumeFields &&
      props.resumeFields.customization &&
      props.resumeFields.customization;

  const editorSettingsData = isJson
    ? json && json.editorSettings && json.editorSettings
    : props &&
      props.resumeFields &&
      props.resumeFields.editorSettings &&
      props.resumeFields.editorSettings;

  // const { isTitleBackgroundColor } = editorSettingsData;

  // For PreviewGeneratePage
  const multiColorOptions =
    dataCustomize &&
    dataCustomize.fonts &&
    dataCustomize.fonts.multi_color_option;

  let primaryColor_imageGenerate = "#3AB0FF";
  let secondaryColor_primaryColor_imageGenerate = "#FFB562";
  if (multiColorOptions) {
    const randomIndex = Math.floor(Math.random() * multiColorOptions.length);
    const randomElement = multiColorOptions[randomIndex];

    primaryColor_imageGenerate = randomElement?.primary_color;
    secondaryColor_primaryColor_imageGenerate = randomElement?.secondary_color;
  }

  const {
    fontSize,
    titleFont,
    bodyFont,
    primaryColor,
    secondaryColor,
    descriptionColor,
    sectionTitleColor,
    bgColor,
    linkColor,
    titleBgColor,
    background,
    PageMargin,
    SectionMargin,
    bg_color_options,
    multi_color_option,
  } = dataCustomize && dataCustomize ? dataCustomize : "";

  const selectedBgColor = bgColor && bgColor;

  const styles = {
    primaryColor:
      pathname && pathname.includes("previewimageGenerate")
        ? primaryColor_imageGenerate
        : primaryColor,
    secondaryColor:
      pathname && pathname.includes("previewimageGenerate")
        ? secondaryColor_primaryColor_imageGenerate
        : secondaryColor,
    sectionTitleColor: sectionTitleColor,
    bgColor: bgColor,
    linkColor: linkColor,
    titleFont: titleFont,
    bodyFont: bodyFont,
    descriptionColor: descriptionColor,
    titleBgColor: titleBgColor,
    background: background,
    selectedFont: fontVariations[fontSize - 1],
    selectedBgColor: selectedBgColor,
    isMandatoryDescriptionColor: false,
  };

  useEffect(() => {
    setTempData(templateData);
  }, [templateData]);
  // useEffect(() => {
  //   if (pdfResume && pdfResume.data) {
  //     toast.success(pdfResume && pdfResume.data.data.message);
  //   };
  // }, [pdfResume]);

  const handleHide = () => {
    setShowLogin(false);
  };

  function showTemplateNewPopup() {
    if (tempData && tempData.status && tempData.status == "2") {
      setShowWarningPopup(true);
    } else {
      props.ShowTemplate();
    }
  }
  const showSamplePopup = () => {
    props.showSamplePopup();
  };
  const showTemplatePopupForAppUser = () => {
    setShowWarningPopup(false);
    props.ShowTemplate();
  };
  const handleHideWarning = () => {
    setShowWarningPopup(false);
  };
  const handlePreview = () => {
    setClickedPreview(true);
    const calculatedData = CalculatecompletedPercentage(
      props && props.resumeFields
    );
    if (calculatedData && calculatedData.completedPercentage < 100) {
      setShowMissingFieldsPopup(true);
    } else {
      setShowPreview(true);
    }
  };

  const hidePreview = () => {
    setShowPreview(false);
    setIsSample(false);
  };
  const showCustomColor = () => {};

  //For Font Size

  // const fontSize = styles && styles.bodyFontSize;
  const [value, setValue] = useState();
  const [dragEnd, setDragEnd] = useState(false);
  // const removePx = fontSize?.split("px").shift();

  // useEffect(() => {
  //   setValue(removePx);
  // }, [fonts]);

  //   useEffect(() => {
  //     if (dragEnd) {
  //       handleSize(value);
  //     }
  //   }, [value]);

  const handleChange = (e) => {
    let size = e.target.value;
    setValue(size);
    // setDragEnd(true);
    props.sizeHandler(
      "titleFontSize",
      `${parseInt(size) + 8}px`,
      "bodyFontSize",
      `${size}px`
    );
  };
  //   const handleSize = (size) => {
  //     props.sizeHandler(
  //       "titleFontSize",
  //       `${parseInt(size) + 8}px`,
  //       "bodyFontSize",
  //       `${size}px`
  //     );
  //   };
  const handleBlur = (e) => {
    props.resumeUpdate(e, "visual");
  };

  const handleCustomColor = (e) => {
    props.resumeUpdate(e, "visual");
  };
  //For Custom Color

  //For Change background
  const handleImageChange = (img, index) => {
    props.backgroundUpdate(img);
  };

  function undo(e) {
    setRandUpdate(true);
    let data = history;
    if (data.currentIndex > 0) {
      let undoContent = data.timeline[data.currentIndex - 1].editorData;
      props.setResumeFields(undoContent);
      data.currentIndex = data.currentIndex - 1;
      dispatch(undoRedo({ history: data }));
    }
  }
  useEffect(() => {
    if (randUpdate) {
      props.resumeUpdate(true, "undo");
      setRandUpdate(false);
    }
  }, [props.resumeFields]);

  function redo(e) {
    let data = history;
    setRandUpdate(true);
    if (data.currentIndex >= 0) {
      let timeLineLength = data.timeline.length;
      if (data.currentIndex + 1 <= timeLineLength) {
        let undoContent = data.timeline[data.currentIndex + 1].editorData;
        props.setResumeFields(undoContent);
        data.currentIndex = data.currentIndex + 1;
        dispatch(undoRedo({ history: data }));
      }
    }
  }

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.ctrlKey && evt.keyCode == 90) {
      undo();
    } else if (evt.ctrlKey && evt.keyCode == 89) {
      redo();
    }
  };

  // useEffect(() => {
  //   if (dropdownRef.current.classList.contains("my-class")) {
  //   }
  // }, []);

  const dropdownToggle = () => {
    setTimeout(() => {
      if (dropdownRef.current.classList.contains("show")) {
        setHasClass(true);
      } else {
        setHasClass(false);
      }
    }, 100);
  };

  // const overflow = {
  //   overflowX:
  //     hasClass && window.innerWidth < 1200
  //       ? "inherit"
  //       : !hasClass && window.innerWidth < 1200
  //       ? "scroll"
  //       : "",
  // };
  const [modal, setModal] = useState(false);

  const handleToggle = () => {
    setClickedPreview(false);
    props.resumeUpdateToServer();
    if (path && path.includes("create")) {
      setShowLogin(true);
    } else {
      const calculatedData = CalculatecompletedPercentage(
        props && props.resumeFields
      );
      if (modal) {
        setModal(!modal);
      } else {
        if (calculatedData && calculatedData.completedPercentage < 100) {
          setShowMissingFieldsPopup(true);
        } else {
          if (userType && userType == "free") {
            let data =
              props &&
              props.resumeFields &&
              props.resumeFields.lockedFeatures &&
              props.resumeFields.lockedFeatures;
            if (data && data.length > 0) {
              setShowProPopup(true);
              setPopupType("download");
              setShowProPopupMessage("Please upgrade to Pro");
            } else {
              setModal(!modal);
            }
          } else {
            setModal(!modal);
          }
        }
      }
    }
  };
  const handleAddSection = () => {
    setShowAddSection(!showAddSection);
  };

  const handleDesign = () => {
    setShowDesignSection(!showDesignSection);
  };

  const handleMediumDesignbar = () => {
    setShowMediumDesignbar(!showMediumDesignbar);
  };
  const [openSection, setOpenSection] = useState(false);
  const [openFonts, setOpenFonts] = useState(false);
  const [openImprove, setOpenImprove] = useState(false);
  const [openColors, setOpenColors] = useState(false);
  const [openBackground, setOpenBackground] = useState(false);
  const [openLayout, setOpenLayout] = useState(false);

  const toggleSectionAccordion = () => {
    setOpenSection(!openSection);
  };
  const toggleFontsAccordion = () => {
    setOpenFonts(!openFonts);
  };
  const toggleImproveAccordion = () => {
    setOpenImprove(!openImprove);
  };
  const toggleColorsAccordion = () => {
    setOpenColors(!openColors);
  };

  const toggleBackgroundAccordion = () => {
    setOpenBackground(!openBackground);
  };

  const toggleLayoutAccordion = () => {
    setOpenLayout(!openLayout);
  };

  //For Missing Fields popup
  const handleHideShowMissingFieldsPopup = () => {
    setShowMissingFieldsPopup(false);
  };

  const showPreviewPopup = () => {
    if (clickedPreview) {
      setShowPreview(true);
    } else {
      if (userType && userType == "free") {
        let data =
          props &&
          props.resumeFields &&
          props.resumeFields.lockedFeatures &&
          props.resumeFields.lockedFeatures;
        if (data && data.length > 0) {
          setShowProPopup(true);
          setPopupType("download");
          setShowProPopupMessage("Please upgrade to Pro");
        } else {
          setModal(!modal);
        }
      } else {
        setModal(!modal);
      }
    }
    setShowMissingFieldsPopup(false);
  };

  //layout change A4 or letter
  const handleLayoutChange = (checked) => {
    let data = { ...props.resumeFields };
    const body = {
      title:
        resume && resume.resume && resume.resume.title
          ? resume.resume.title
          : "",
      body: "Body",
      content: JSON.stringify(data),
      completed: false,
      isLetter: checked == "letter" ? 1 : 0,
      type: "resume",
      template_id: resume && resume.resume && resume.resume.template_id,
    };

    dispatch(resumeEditActions(id, body, "sizeHandle"));
  };

  const openCustomColorHandler = () => {
    setCustomOpen(true);
  };

  return (
    <>
      <ReactTooltip />
      {/* <ToastContainer
        toastStyle={{
          backgroundColor: "#009c61",
          width: "203px",
          fontSize: "12px",
          minHeight: "30px",
          float: "right",
          marginTop: "15%",
        }}
        position="top-right"
        hideProgressBar
        autoClose={2000}
        draggable
      /> */}
      <WarningPopup
        show={showWarningPopup}
        hide={handleHideWarning}
        showTemplatePopup={showTemplatePopupForAppUser}
      />
      <MissingFieldsPopup
        show={showMissingFieldsPopup}
        hide={handleHideShowMissingFieldsPopup}
        showPreview={showPreviewPopup}
        resumeFields={props && props.resumeFields}
        setSection={props.setSection}
      />
      <PreviewResume
        id={props.id}
        cover={props.cover}
        showPreview={showPreview}
        hidePreview={hidePreview}
        setIsSample={props.setIsSample}
      />
      <LoginPopup
        show={showLogin}
        hide={handleHide}
        resumeFields={props.resumeFields}
        setResumeFields={props.setResumeFields}
      />

      <div className="parent-desingerbar ">
        <div
          className=" px-2 align-items-center designbar"
          // style={overflow}
        >
          <div className="">
            <div className="btn-wrapper">
              {props?.isVisualEditor && (
                <>
                  <div className="d-flex  w-100">
                    <div className="history-btn-wrapper pt-0 pl-0 w-100 mr-2">
                      <button>
                        {historyUndoRedo?.history?.currentIndex > 0 ? (
                          <div onClick={(e) => props.undo("undo")}>
                            <img
                              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/undo.svg`}
                              className="mr-2"
                            />
                            Undo
                          </div>
                        ) : (
                          <>
                            <div style={{ opacity: "0.5" }}>
                              <img
                                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/undo.svg`}
                                className="mr-2"
                              />
                              Undo
                            </div>
                          </>
                        )}
                      </button>
                    </div>
                    <div className="history-btn-wrapper pt-0  w-100">
                      {historyUndoRedo && (
                        <button>
                          {historyUndoRedo.history.currentIndex !=
                          historyUndoRedo.history.timeline.length - 1 ? (
                            <div onClick={(e) => props.redo("redo")}>
                              <img
                                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/redo.svg`}
                                className="mr-2"
                              />{" "}
                              Redo
                            </div>
                          ) : (
                            <>
                              <div style={{ opacity: "0.5" }}>
                                <img
                                  src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/redo.svg`}
                                  className="mr-2"
                                />{" "}
                                Redo
                              </div>
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  {/* <div className="toolbox-separator"></div> */}
                </>
              )}
            </div>

            <div className="btn-wrapper">
              <button
                onClick={toggleLayoutAccordion}
                aria-expanded={openLayout}
                aria-controls="accordion-content"
                className={
                  openLayout ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Page Size
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openLayout ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openLayout}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openLayout ? " open" : ""}`}
                >
                  <div className="">
                    {/* Font Color Select */}
                    <div className="font-color-section">
                      <div className="row mt-2 justify-content-between ">
                        <p
                          className="pt-2 col-md-6"
                          style={{ fontSize: "12px" }}
                        >
                          Document size:
                        </p>
                        <div className="col-md-6">
                          <div className="row type-switch-div justify-content-between">
                            <div
                              className={
                                sleectedResume &&
                                sleectedResume &&
                                sleectedResume.isLetter
                                  ? ` type-switch-selected col-md-6 type-switch`
                                  : "col-md-6 type-switch"
                              }
                              onClick={() =>
                                handleLayoutChange("letter", "document_size")
                              }
                            >
                              Letter
                            </div>
                            <div
                              className={
                                sleectedResume &&
                                sleectedResume &&
                                sleectedResume.isLetter
                                  ? ` col-md-6 type-switch`
                                  : " type-switch-selected col-md-6 type-switch"
                              }
                              onClick={() =>
                                handleLayoutChange("a4", "document_size")
                              }
                            >
                              A4
                            </div>
                          </div>
                        </div>

                        {/* <StepRange /> */}
                        <span style={{ fontSize: "12px" }}>Page Margin</span>
                        <input
                          type="range"
                          min="1"
                          max="4"
                          step="1"
                          onChange={props.handlePageMargin}
                          value={PageMargin}
                        />
                        <span style={{ fontSize: "12px" }}>Section Margin</span>
                        <input
                          type="range"
                          min="1"
                          max="4"
                          step="1"
                          onChange={props.handleSectionMargin}
                          value={SectionMargin}
                        />
                        {/* <div className="p-0 mr-2">
                <BootstrapSwitchButton
                  checked={
                    resume && resume.resume && resume.resume.isLetter
                      ? true
                      : false
                  }
                  onstyle="outline-success"
                  offstyle="outline-success"
                  width={77}
                  onlabel="Letter"
                  offlabel="A4"
                  size="sm"
                  onChange={(checked) => handleChange(checked, "document_size")}
                />
              </div> */}
                      </div>
                    </div>
                    {/* Resume Background Select */}
                  </div>
                </div>
              </Collapse>
            </div>

            {/* <div className="btn-wrapper add-btn-wrapper">
              <button onClick={handleAddSection}>
                <span className="">
                  <i class="fa fa-pencil-square-o mr-2" aria-hidden="true"></i>{" "}
                  Add Section
                </span>
              </button>
            </div> */}
            {/* <div className="btn-wrapper">
              <Dropdown className="d-inline mx-2 add-section-dropdown">
                <Dropdown.Toggle id="dropdown-autoclose-false">
                  <span className="d-none d-md-inline">Add Section</span>
                  <span className="d-md-none">Add</span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className={`dropdown_menu_toggle  ${props.subClass}`}
                  id="available_section"
                >
                  {availableSection.map((sectionData, index) => (
                    <SectionItem
                      key={index}
                      sectionData={sectionData}
                      sectionType={props.sectionType}
                      // setSection={setSection}
                      // checkSectionPresentOrNot={checkSectionPresentOrNot}
                    />
                  ))}
                  <Dropdown.Item className="check">
                    <a
                      className="d-flex justify-content-between w-100"
                      href="javascript:void(0);"
                      // onClick={(e) =>
                      //   setSection("customDate", props.sectionType)
                      // }
                    >
                      <div>
                        <img
                          src="/images/interest.svg"
                          alt="addicon"
                          className="img-add-section"
                        />
                        Custom Date Section
                      </div>
                      <img
                        src="/images/plus menu.svg"
                        alt="addicon"
                        className="img-add-plus-section ml-2"
                      />
                    </a>
                  </Dropdown.Item>
                  <Dropdown.Item className="check">
                    <a
                      className="d-flex justify-content-between w-100"
                      href="javascript:void(0);"
                      // onClick={(e) =>
                      //   setSection("customText", props.sectionType)
                      // }
                    >
                      <div>
                        <img
                          src="/images/interest.svg"
                          alt="addicon"
                          className="img-add-section"
                        />
                        Custom Text Section
                      </div>
                      <img
                        src="/images/plus menu.svg"
                        alt="addicon"
                        className="img-add-plus-section ml-2"
                      />
                    </a>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
            <div className="btn-wrapper pt-0">
              <button
                onClick={toggleSectionAccordion}
                aria-expanded={openSection}
                aria-controls="accordion-content"
                className={
                  openSection ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-plus mr-2" aria-hidden="true"></i> Add Section
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openSection ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openSection}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openSection ? " open" : ""}`}
                >
                  {availableSection.map((sectionData, index) => (
                    <SectionItem
                      key={index}
                      sectionData={sectionData}
                      sectionType={props.sectionType}
                      setSection={props.setSection}
                      checkSectionPresentOrNot={props.checkSectionPresentOrNot}
                    />
                  ))}
                  <div>
                    <div
                      className="d-flex justify-content-between w-100 cursor mb-2"
                      onClick={(e) => props.setSection("customDate", "lsbar")}
                      style={{ fontSize: "14px" }}
                    >
                      <div style={{ fontSize: "14px" }}>
                        <i class="fa fa-pencil mr-2" aria-hidden="true"></i>
                        Custom Date Section
                      </div>
                      <div className="add-section-crown-icon">
                        <img className="w-100" src="./images/crown-black.png" />
                      </div>
                    </div>
                    <div className="toolbox-separator"></div>
                  </div>
                  <div>
                    <div
                      className="d-flex justify-content-between w-100 cursor mb-2"
                      onClick={(e) => props.setSection("customText", "lsbar")}
                      style={{ fontSize: "14px" }}
                    >
                      <div style={{ fontSize: "14px" }}>
                        <i class="fa fa-pencil mr-2" aria-hidden="true"></i>
                        Custom Text Section
                      </div>
                      {/* <i class="fa fa-plus" aria-hidden="true"></i> */}
                      <div className="add-section-crown-icon">
                        <img className="w-100" src="./images/crown-black.png" />
                      </div>
                    </div>
                    {/* <div className="toolbox-separator"></div> */}
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="btn-wrapper">
              <button onClick={showSamplePopup}>
                <i class="fa fa-database mr-2" aria-hidden="true"></i> Import
                Content
              </button>
            </div>

            <div className="btn-wrapper">
              <button
                // onClick={toggleSectionAccordion}
                // aria-expanded={openSection}
                aria-controls="accordion-content"
                className={
                  openSection ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-file-text-o mr-2" aria-hidden="true"></i>{" "}
                Template
                <span className="icon-container"></span>
              </button>
              <Collapse in={true}>
                <div
                  id="accordion-content"
                  className={`accordion-content open`}
                >
                  <Qrtemplate showTemplateNewPopup={showTemplateNewPopup} />
                </div>
              </Collapse>
            </div>

            <div className="btn-wrapper">
              <button onClick={props.showRearrange}>
                <i class="fa fa-th mr-2" aria-hidden="true"></i> Rearrange
              </button>
            </div>
            {/* <div className="btn-wrapper design-btn-wrapper">
              <button onClick={handleDesign}>
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Design
              </button>
            </div> */}
            {/* <div className="btn-wrapper">
              <button
                onClick={toggleImproveAccordion}
                aria-expanded={openImprove}
                aria-controls="accordion-content"
                className={
                  openImprove ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-font mr-2" aria-hidden="true"></i> Improve Text
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openImprove ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openImprove}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openImprove ? " open" : ""}`}
                >
                  <p style={{ fontSize: "10px" }}>
                    <p>Grammar & Error corrections</p>
                    {Object.keys(improveTexts).map((section) => (
                      <div key={section}>
                        <h4 style={{ fontSize: "14px" }}>{section}</h4>
                        <ul>
                          {improveTexts[section].errors.map((error, index) => (
                            <li key={index}>{error}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </p>
                </div>
              </Collapse>
            </div> */}
            <div className="btn-wrapper">
              <button
                onClick={toggleFontsAccordion}
                aria-expanded={openFonts}
                aria-controls="accordion-content"
                className={
                  openFonts ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-font mr-2" aria-hidden="true"></i> Fonts
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openFonts ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openFonts}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openFonts ? " open" : ""}`}
                >
                  <div className="">
                    {/* Font Size */}
                    {/* <StepRange /> */}
                    <span style={{ fontSize: "12px" }}>Font Size</span>
                    <input
                      type="range"
                      min="1"
                      max="4"
                      step="1"
                      onChange={(e) => props.sizeHandler(e)}
                      value={fontSize}
                    />
                    {/* <div className="mb-3  pt-2">
                      <label className="formlable d-block">Font Size</label>

                      <div className="size_btn_editor">
                        <input
                          type="range"
                          className="range_slider range_slider_width"
                          min="11"
                          max="16"
                          name="level"
                          value={value}
                          onChange={(e) => handleChange(e)}
                          onBlur={handleBlur}
                        />
                        <span className="font_size_handler">{value} px</span>
                      </div>
                    </div> */}
                    {/* Font Size */}
                    {/* Font Selection */}

                    <div className="mb-3">
                      {fontSelection &&
                        fontSelection.map((res, index) => (
                          <>
                            <label className="formlable d-block">
                              {res.label}
                            </label>

                            <div className="select-div position-relative">
                              <select
                                onChange={(e) => props.fontHandler(e, res.name)}
                                value={styles && styles[res.name]}
                                className="form-control  editor-font-input"
                                style={{ appearance: "none" }}
                              >
                                {res &&
                                  res.font.map((response) => (
                                    <option
                                      style={{ fontFamily: response }}
                                      value={response}
                                    >
                                      {response}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="btn-wrapper">
              <button
                onClick={toggleColorsAccordion}
                aria-expanded={openColors}
                aria-controls="accordion-content"
                className={
                  openColors ? "accordion-button active" : "accordion-button"
                }
              >
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Colors
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openColors ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openColors}>
                <div
                  id="accordion-content"
                  className={`accordion-content${openColors ? " open" : ""}`}
                >
                  <div className="">
                    {/* Font Color Select */}
                    <div className="font-color-section">
                      {/* Bg color option */}

                      {/* <div>
                        <label className="formlable d-block">
                          Background varients
                        </label>
                        <div className="row m-0">
                          {bg_color_options &&
                            bg_color_options &&
                            bg_color_options.map((res, index) => (
                              <div className="col-md-3">
                                <div
                                  className="multicircle mx-2 cursor"
                                  onClick={() => props.bgColorHandler(index)}
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    backgroundColor: "red",
                                    display: "flex",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.lsbar,
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.rsbar,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div> */}

                      <div className=" mt-2" style={{ position: "relative" }}>
                        <label className="formlable d-block">
                          Theme colors
                        </label>
                        <div className="row m-0">
                          {bgColor &&
                            bgColor.varients.map((res, index) => (
                              <div className="col-md-3 mb-2 p-0">
                                <div
                                  className="multicircle mx-2 cursor"
                                  onClick={() => props.bgColorHandler(res)}
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    backgroundColor: "red",
                                    display: "flex",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res,
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}

                          <div className="col-md-3 mb-2 p-0">
                            <div
                              className="multicircle mx-2 cursor custom-color-icon"
                              onClick={() => openCustomColorHandler()}
                              style={{
                                width: "30px",
                                height: "30px",
                                backgroundColor: "red",
                                display: "flex",
                                borderRadius: "50%",
                                overflow: "hidden",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  // backgroundColor: res,
                                  background:
                                    "conic-gradient(from 135deg at 50% 50%, rgb(228, 58, 58) 0deg, rgb(224, 202, 83) 45deg, rgb(103, 199, 69) 95deg, rgb(66, 218, 163) 145deg, rgb(49, 187, 231) 190deg, rgb(56, 81, 214) 230deg, rgb(143, 0, 255) 280deg, rgb(231, 54, 160) 320deg, rgb(201, 73, 73) 360deg)",
                                }}
                              ></div>
                              {/* <div
                                style={{
                                  width: "50%",
                                  height: "100%",
                                  background:
                                    "conic-gradient(from 135deg at 50% 50%, rgb(228, 58, 58) 0deg, rgb(224, 202, 83) 45deg, rgb(103, 199, 69) 95deg, rgb(66, 218, 163) 145deg, rgb(49, 187, 231) 190deg, rgb(56, 81, 214) 230deg, rgb(143, 0, 255) 280deg, rgb(231, 54, 160) 320deg, rgb(201, 73, 73) 360deg)",
                                  // backgroundColor: res,
                                }}
                              ></div> */}
                            </div>
                          </div>
                          {customOpen && (
                            <OutsideClickHandler
                              onOutsideClick={(e, value) => {
                                const parentWithClass = e.target.closest(
                                  ".customColorPicker-editor"
                                );
                                const anotherParentWithClass =
                                  e.target.closest(".custom-color-icon");
                                if (
                                  customOpen &&
                                  parentWithClass == null &&
                                  anotherParentWithClass == null
                                ) {
                                  setCustomOpen(false);
                                } else if (
                                  customOpen &&
                                  parentWithClass != ""
                                ) {
                                  setCustomOpen(true);
                                }
                              }}
                            >
                              <div className="customColorPicker-editor">
                                <HexColorPicker
                                  color={bgColor?.bgColor}
                                  onChange={(e) => props.bgColorHandler(e)}
                                  onBlur={(e) => props.resumeUpdate(e)}
                                />
                              </div>
                            </OutsideClickHandler>
                          )}
                        </div>
                        <div className="toolbox-separator"></div>

                        <label className="formlable d-block">Colors</label>
                        <div className="row m-0">
                          {multi_color_option &&
                            multi_color_option.map((res, index) => (
                              <div className="col-md-3">
                                <div
                                  className="multicircle mx-2 cursor"
                                  onClick={() =>
                                    props.multiColorHandler(
                                      res.primary_color,
                                      res.secondary_color
                                    )
                                  }
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    backgroundColor: "red",
                                    display: "flex",
                                    borderRadius: "50%",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.primary_color,
                                    }}
                                  ></div>
                                  <div
                                    style={{
                                      width: "50%",
                                      height: "100%",
                                      backgroundColor: res.secondary_color,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}
                        </div>
                        <div className="toolbox-separator mt-3"></div>

                        <label className="formlable d-block pt-3">
                          Use custom color :
                        </label>

                        {customColor &&
                          customColor.map((res, index) => (
                            <>
                              {res.varient == "titleBgColor" ? (
                                <>
                                  {editorSettingsData &&
                                    editorSettingsData.isTitleBackgroundColor && (
                                      <div className="mb-2" key={index}>
                                        <label className="formlable">
                                          {res.label}
                                        </label>
                                        <ul className="fontbtn editor-color-picker d-flex justify-content-between">
                                          <li className="w-100">
                                            <div className="background">
                                              <label className="color-selector">
                                                <span
                                                  className="circle"
                                                  style={{
                                                    background:
                                                      styles &&
                                                      styles[res.varient],
                                                  }}
                                                />
                                                <span>
                                                  {styles &&
                                                    styles[res.varient]}
                                                </span>

                                                <input
                                                  id={`color${index}`}
                                                  type="color"
                                                  className="hidden"
                                                  value={
                                                    styles &&
                                                    styles[res.varient]
                                                  }
                                                  onChange={(e) =>
                                                    props.colorHandler(
                                                      e,
                                                      res.varient
                                                    )
                                                  }
                                                  onBlur={handleCustomColor}
                                                  style={{ cursor: "pointer" }}
                                                />
                                              </label>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                </>
                              ) : (
                                <>
                                  <div className="mb-2" key={index}>
                                    <label className="formlable">
                                      {res.label}
                                    </label>
                                    <ul className="fontbtn editor-color-picker d-flex justify-content-between">
                                      <li className="w-100">
                                        <div className="background">
                                          <label className="color-selector">
                                            <span
                                              className="circle"
                                              style={{
                                                background:
                                                  styles && styles[res.varient],
                                              }}
                                            />
                                            <span>
                                              {styles && styles[res.varient]}
                                            </span>

                                            <input
                                              id={`color${index}`}
                                              type="color"
                                              className="hidden"
                                              value={
                                                styles && styles[res.varient]
                                              }
                                              onChange={(e) =>
                                                props.colorHandler(
                                                  e,
                                                  res.varient
                                                )
                                              }
                                              onBlur={handleCustomColor}
                                              style={{ cursor: "pointer" }}
                                            />
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </>
                              )}
                            </>
                          ))}
                      </div>
                      {/* Font Color Select */}
                      <div className="toolbox-separator"></div>
                      {/* Resume Background Select */}
                    </div>
                    {/* Resume Background Select */}
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Background */}

            <div className="btn-wrapper">
              <button
                onClick={toggleBackgroundAccordion}
                aria-expanded={openBackground}
                aria-controls="accordion-content"
                className={
                  openBackground
                    ? "accordion-button active"
                    : "accordion-button"
                }
              >
                <i class="fa fa-tint mr-2" aria-hidden="true"></i> Backgrounds
                <span className="icon-container">
                  <i
                    className={`fa ${
                      openBackground ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </span>
              </button>
              <Collapse in={openBackground}>
                <div
                  id="accordion-content"
                  className={`accordion-content${
                    openBackground ? " open" : ""
                  }`}
                >
                  <div className="">
                    {/* Font Color Select */}
                    <div className="font-color-section">
                      <label className="formlable d-block mt-2">
                        Background
                      </label>
                      <div className="d-flex">
                        <p
                          className="pt-2 col-md-6"
                          style={{ fontSize: "12px" }}
                        >
                          Visibility:
                        </p>
                        <div className="col-md-6">
                          <div className="row type-switch-div justify-content-between">
                            <div
                              className={
                                styles &&
                                styles.background &&
                                styles.background.bgShow
                                  ? ` type-switch-selected col-md-6 type-switch`
                                  : "col-md-6 type-switch"
                              }
                              onClick={() => props.showHideBackground()}
                            >
                              Show
                            </div>
                            <div
                              className={
                                styles &&
                                styles.background &&
                                styles.background.bgShow
                                  ? ` col-md-6 type-switch`
                                  : " type-switch-selected col-md-6 type-switch"
                              }
                              onClick={() => props.showHideBackground()}
                            >
                              Hide
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row m-0">
                        {backgroundImage &&
                          backgroundImage.map((res, index) => (
                            <div
                              key={index}
                              className="col-md-3 mt-2 change_modal_row"
                            >
                              {background && background.bgImage == res ? (
                                <>
                                  <div className="  backimg_select image_change_modal_img_div">
                                    <div
                                      style={{ cursor: "pointer" }}
                                      className={`background_change background_b0${index}`}
                                      onClick={() =>
                                        handleImageChange(res, index)
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                <div className=" image_change_modal_img_div">
                                  <div
                                    style={{ cursor: "pointer" }}
                                    className={`background_change  background_b0${index}`}
                                    onClick={() =>
                                      handleImageChange(res, index)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* Resume Background Select */}
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Layouts */}

            {/* <div className="btn-wrapper designbar-template">
              <button onClick={showTemplatePopup}>
                <i class="fa fa-file-text-o mr-2" aria-hidden="true"></i>{" "}
                Templates
              </button>
            </div> */}
          </div>
          <div className="">
            <div className="btn-wrapper">
              <button onClick={handlePreview}>
                <span className="">
                  <i class="fa fa-eye mr-2" aria-hidden="true"></i> Preview
                </span>
              </button>
            </div>
            <div className="btn-wrapper">
              <button onClick={() => props.shareShow()}>
                <span className="">
                  <i class="fa fa-share-alt mr-2" aria-hidden="true"></i> Share
                </span>
              </button>
            </div>
            <div className="btn-wrapper">
              <button onClick={() => props.showHistoryModal()}>
                <span className="">
                  <i class="fa fa-share-alt mr-2" aria-hidden="true"></i>{" "}
                  History
                </span>
              </button>
            </div>
            <div className="btn-wrapper">
              <button onClick={() => handleToggle()}>
                <span className="">
                  <i class="fa fa-download mr-2" aria-hidden="true"></i>{" "}
                  Download
                </span>
              </button>
              {modal && modal && (
                <DownloadPopup
                  show={modal}
                  handleToggle={handleToggle}
                  type="resume"
                  resumedata={props.resumeFields}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditorHeader;
